// extracted by mini-css-extract-plugin
export var content = "section-module--content--150d3";
export var header = "section-module--header--af589";
export var headerDark = "section-module--headerDark--bc65f";